module.exports = __webpack_public_path__ + "static/media/client-12.29e41e3d.jpg";